<template>
  <InternalLoading
    v-if="!uiBlock"
    v-bind="{
      type,
      size,
      modelValue,
      color,
      uiBlock,
    }"
  >
    <slot />
  </InternalLoading>
  <SbBlockUI v-else>
    <InternalLoading
      v-bind="{
        type,
        size,
        modelValue,
        color,
        uiBlock,
      }"
    >
      <slot />
    </InternalLoading>
  </SbBlockUI>
</template>

<script lang="ts" setup>
import SbBlockUI from '../BlockUI'
import InternalLoading from './components/InternalLoading.vue'
import type { SbLoadingProps } from './types'

defineProps<SbLoadingProps>()
</script>

<style lang="scss">
@import './loading';
</style>
